/** @jsx jsx */

import { jsx, render, SelectionSet, Field, Variable, Mutation } from "graphql-jsx";
import { clients } from "utils/clients";
import { UuidScalar, ArrayScalar, ValidTypeScalar } from "GraphQL/Scalars";
import { ValidType } from "constants/ValidType";

type Option = Readonly<{
  uuid: string;
  validCheck?: ValidType;
  visibleField?: string[] | null;
}>;

export const UpdatePlaylistUsersRelation = async (option: Option) => {
  const $uuid = <Variable name="uuid" scalar={<UuidScalar />} value={option.uuid} />;
  const $visibleField = <Variable name="visibleField" scalar={<ArrayScalar isNullable />} value={option.visibleField} />;
  const $validCheck = <Variable name="validCheck" scalar={<ValidTypeScalar isNullable />} value={option.validCheck} />;
  const { query, variables } = render(
    <Mutation operationName="UPDATE_PLAYLIST_URL">
      <SelectionSet
        name="updatePlaylist_users_relation"
        alias="updatePlaylistUsersRelation"
        argument={{
          where: {
            id: $uuid
          },
          data: {
            visible_field: $visibleField,
            valid_check: $validCheck
          }
        }}
      >
        <Field name="id" />
      </SelectionSet>
    </Mutation>
  );
  type Data = Readonly<{
    updatePlaylistUsersRelation: Readonly<{
      id: string;
    }>[];
  }>;
  return await clients.playlist.request<Data>(query, variables);
};
